<div class="flex flex-col gap-2 ">
    <label for="saldo" class="text-lg font-bold">Op te laden bedrag</label>
    <aeg-field-validation-wrapper :error-message="errors.amount" name="Op te laden bedrag" mod-hidden-label mod-required #default="{hasErrors}">
        <InputNumber :invalid="hasErrors" name="Saldo" id="saldo" mode="currency" currency="EUR" locale="nl-BE" v-model="amount" v-bind="amountProps" />
    </aeg-field-validation-wrapper>
</div>
